import { useDownloadLegalClientQuestionnaire as useDownloadLegalClientQuestionnaireApi } from 'api/requests/legal';
import { downloadBase64File } from 'helpers';
import { useServerErrorNotify } from 'hooks';

export const useDownloadLegalClientQuestionnaire = () => {
  const { downloadLegalClientQuestionnaire, error } =
    useDownloadLegalClientQuestionnaireApi();

  const handleDownloadLegalClientQuestionnaire = async (
    legalClientId: string
  ) => {
    const res = await downloadLegalClientQuestionnaire(legalClientId);
    if (res) {
      downloadBase64File(res, 'application/pdf');
    }
  };

  useServerErrorNotify(error);

  return {
    error,
    downloadLegalClientQuestionnaire: handleDownloadLegalClientQuestionnaire,
  };
};
